import { Provider } from 'components/Tooltip'
import { NaturalLanguageResponseSegment } from 'features/cantileverAISystem'
import React from 'react'
import styled from 'styled-components'

import { CitationTooltip } from './CitationTooltip'

interface AIResponseMessageProps {
  segments: NaturalLanguageResponseSegment[]
}

const ResponseContainer = styled.div`
  color: ${({ theme }) => theme.forecast.defaultText};
`

const SegmentText = styled.p`
  margin: 0 0 1rem 0;

  &:last-child {
    margin-bottom: 0;
  }
`

export const AIResponseMessage: React.FC<AIResponseMessageProps> = ({
  segments,
}) => {
  return (
    <Provider delayDuration={200}>
      <ResponseContainer>
        {segments.map((segment, segmentIdx) => {
          const citations = segment.citations || []
          return (
            <SegmentText key={segmentIdx}>
              {segment.text}
              {citations.length > 0 && (
                <>
                  {citations.map((citation) => (
                    <CitationTooltip
                      key={`${citation.entryId}`}
                      citation={citation}
                    />
                  ))}
                </>
              )}
              {segmentIdx < segments.length - 1 && ' '}
            </SegmentText>
          )
        })}
      </ResponseContainer>
    </Provider>
  )
}
